import { Component, Vue } from 'vue-property-decorator';
import WithRender from './bankingdetails.html';
import VuePhoneNumberInput from "vue-phone-number-input";
import config from '@/settings/config.js';
import _axios from '@/services/axios';
import Loading from 'vue-loading-overlay';


@WithRender
@Component({
  components: {
    VuePhoneNumberInput,
    Loading
  }
})
export default class BankingDetails extends Vue {
}
